import { defineComponent as _defineComponent } from 'vue';
import { computed } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'DatasetErrorDetails',
    props: {
        jobStderr: null,
        toolStderr: null,
        jobMessages: null
    },
    setup(__props) {
        const props = __props;
        const hasMessages = computed(() => {
            return props.jobMessages && props.jobMessages.length > 0;
        });
        const hasDetails = computed(() => {
            return props.toolStderr || props.jobStderr || hasMessages.value;
        });
        return { __sfc: true, props, hasMessages, hasDetails };
    }
});
